import {
  Button,
  CircularProgress,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  Grid,
  IconButton,
  InputLabel,
  Link,
  ListItem,
  ListItemIcon,
  MenuItem,
  Paper,
  TextField,
  Typography,
  withWidth,
} from "@material-ui/core";
import { AccountCircle, Clear, Delete } from "@material-ui/icons";
import AddIcon from "@material-ui/icons/AddCircle";
import React, { useEffect, useRef, useState } from "react";
import { useTranslation } from "react-i18next";
import { useDispatch } from "react-redux";
import { getDevices } from "../../Utils/ApiCalls";
import {
  checkAdmin,
  checkNewSerialNumber,
  contactMethods,
  contactObjectSkeleton,
  getDeviceProfiles,
  getToken,
  getUser,
  getWarehouses,
  getWarrantyStatusText,
  requestErrorHandler,
  TICKET_PRIORITIES,
  ticketStates,
  USER_GROUPS,
} from "../../Utils/Common";
import EnvSettings from "../../Utils/EnvSettings";
import { useStyles } from "../../Utils/Styles";
import DetailTabs from "../../Views/DeviceDetails/DetailTabs";
import { showPopupSnackbar } from "../../redux/actions/snackbarActions";
import ChangesHistory, { ChangesHistoryLayout } from "../ChangesHistory";
import BrowseContactsDialog from "../Contacts/BrowseContactsDialog";
import ContactInfoBadge from "../Contacts/ContactInfoBadge";
import DeviceSearchAutocomplete from "../DeviceSearchAutocomplete";
import DialogAppBar from "../DialogAppBar";
import StockItemSearch from "../StockItems/StockItemSearch";
import Title from "../Title";
import UserSearchAutocomplete from "../UserSearchAutocomplete";
import EmailMessages from "./EmailMessages";
import ExpenseHeader from "./ExpenseHeader";
import ExpenseItem from "./ExpenseItem";
import MediaFiles from "./MediaFiles";

import { useHistory } from "react-router-dom";

const server = EnvSettings.server;

const actionBarStyle = {
  position: "absolute",
  bottom: 0,
  left: 0,
  width: "100%",
  padding: 10,
  backgroundColor: "white",
  boxShadow: "#d6d6d6 0px 0px 15px 0px",
  zIndex: 90,
};

const actionBarSpacerStyle = { height: 100 };

const dialogContentStyle = {
  position: "relative",
  overflow: "hidden",
};

const InputComponent = ({ inputRef, ...other }) => <div {...other} />;
const OutlinedDiv = ({ children, label }) => {
  return (
    <TextField
      variant="outlined"
      label={label}
      multiline
      fullWidth
      focused={false}
      InputLabelProps={{ shrink: true }}
      InputProps={{
        inputComponent: InputComponent,
      }}
      inputProps={{ children: children }}
    />
  );
};

function ExpenseSegment({
  selectedTicket,
  expenseKey,
  ticketData,
  setTicketData,
}) {
  const [edit, setEdit] = useState();
  const [acKey, setACKey] = useState("dsfasdfds");
  const { t } = useTranslation();
  return (
    <>
      <Grid item container spacing={1} style={{ padding: 5 }}>
        <Grid item xs={12}>
          <InputLabel style={{ marginBottom: 3 }}>
            {t("ticketList." + expenseKey)}
          </InputLabel>
        </Grid>
        <Grid item xs={7}>
          <TextField
            size="small"
            fullWidth
            variant="outlined"
            label={t("name")}
            key={acKey + "3"}
            onChange={(e) => {
              setEdit(
                edit
                  ? { ...edit, name: e.target.value }
                  : { name: e.target.value },
              );
            }}
          ></TextField>
        </Grid>
        <Grid item xs={4}>
          <TextField
            size="small"
            fullWidth
            variant="outlined"
            label={t("price")}
            type={"number"}
            key={acKey + "4"}
            onChange={(e) => {
              setEdit(
                edit
                  ? { ...edit, price: e.target.value }
                  : { price: e.target.value },
              );
            }}
          ></TextField>
        </Grid>
        <Grid item xs={1}>
          <IconButton
            size="small"
            color="primary"
            onClick={() => {
              if (edit) {
                var exp = {
                  ...(selectedTicket ? selectedTicket.expenses : {}),
                };
                if (ticketData && ticketData.expenses) {
                  exp = { ...ticketData.expenses };
                }
                var arr = [];
                if (exp[expenseKey]) {
                  arr = [...exp[expenseKey]];
                  arr.push(edit);
                } else {
                  arr.push(edit);
                }
                exp[expenseKey] = [...arr];
                setTicketData({
                  ...ticketData,
                  expenses: { ...exp },
                });
                setACKey(new Date().toISOString());
              }
            }}
          >
            <AddIcon></AddIcon>
          </IconButton>
        </Grid>
      </Grid>
      <Grid item style={{ padding: 5 }}>
        {(ticketData &&
          ticketData.expenses &&
          ticketData.expenses[expenseKey] &&
          ticketData.expenses[expenseKey].length) ||
        (selectedTicket &&
          selectedTicket.expenses &&
          selectedTicket.expenses[expenseKey] &&
          selectedTicket.expenses[expenseKey].length) ? (
          <ExpenseHeader />
        ) : null}
        {[
          ...(ticketData &&
          ticketData.expenses &&
          ticketData.expenses[expenseKey]
            ? ticketData.expenses[expenseKey]
            : selectedTicket &&
                selectedTicket.expenses &&
                selectedTicket.expenses[expenseKey]
              ? selectedTicket.expenses[expenseKey]
              : []),
        ].map((m, i) => (
          <ExpenseItem
            obj={m}
            key={i}
            onClick={() => {
              var exp = {
                ...(selectedTicket ? selectedTicket.expenses : {}),
              };
              if (ticketData && ticketData.expenses) {
                exp = { ...ticketData.expenses };
              }
              var arr = [];
              arr = [...exp[expenseKey]];
              arr = arr.filter((a) => JSON.stringify(a) !== JSON.stringify(m));
              exp[expenseKey] = [...arr];
              setTicketData({ ...ticketData, expenses: { ...exp } });
            }}
          />
        ))}
      </Grid>
    </>
  );
}

const expenseKeys = ["shippingCosts", "outsourcedServices", "travelCosts"];

const getSpareParts = (data) => {
  if (!Array.isArray(data?.expenses?.spareParts)) {
    return [];
  }
  return data.expenses.spareParts;
};

const getExpensePartStockItemId = (part) =>
  part?.stockItemId || part?.StockItemId || part?.StockItem?.id || part?.id;

const getExpensePartSku = (part) =>
  part?.sku || part?.StockItem?.sku || part?.name;

const getExpensePartKey = (part) =>
  JSON.stringify({
    id: getExpensePartStockItemId(part) || null,
    sku: getExpensePartSku(part) || "",
    name: part?.name || "",
    price:
      part?.price === undefined || part?.price === null
        ? ""
        : String(part.price),
    count:
      part?.count === undefined || part?.count === null
        ? ""
        : String(part.count),
  });

const getNewConsumableSpareParts = (selectedTicket, ticketData) => {
  if (!ticketData?.expenses?.spareParts) {
    return [];
  }

  const existingPartCounts = getSpareParts(selectedTicket).reduce(
    (counts, part) => {
      const key = getExpensePartKey(part);
      counts[key] = (counts[key] || 0) + 1;
      return counts;
    },
    {},
  );

  return getSpareParts(ticketData).filter((part) => {
    const key = getExpensePartKey(part);
    if (existingPartCounts[key]) {
      existingPartCounts[key] -= 1;
      return false;
    }

    const count = Number(part.count || 1);
    return (
      count > 0 &&
      (getExpensePartStockItemId(part) || part.sku || part.StockItem)
    );
  });
};

function ConsumeSparePartsDialog({
  open,
  parts,
  warehouses,
  selectedWarehouse,
  setSelectedWarehouse,
  onClose,
  onSkip,
  onConsume,
  loading,
}) {
  const { t } = useTranslation();
  const editableWarehouses = (warehouses || []).filter((w) => w.editableStock);

  return (
    <Dialog
      open={open}
      onClose={loading ? undefined : onClose}
      aria-labelledby="consume-spare-parts-title"
    >
      <DialogTitle id="consume-spare-parts-title">
        {t("ticketList.consumePartsFromWarehouse")}
      </DialogTitle>
      <DialogContent>
        <Grid container spacing={2}>
          <Grid item xs={12}>
            <Typography>{t("ticketList.consumePartsDescription")}</Typography>
          </Grid>
          <Grid item xs={12}>
            <TextField
              select
              fullWidth
              variant="outlined"
              label={t("stockModule.warehouse")}
              value={selectedWarehouse || ""}
              disabled={loading || !editableWarehouses.length}
              onChange={(e) => {
                setSelectedWarehouse(e.target.value);
              }}
            >
              {editableWarehouses.map((warehouse) => (
                <MenuItem
                  key={warehouse.id || warehouse.value || warehouse.name}
                  value={warehouse.name || warehouse.value}
                >
                  {warehouse.label || warehouse.name}
                </MenuItem>
              ))}
            </TextField>
          </Grid>
          <Grid item xs={12}>
            <Typography style={{ fontWeight: "bold" }}>
              {t("ticketList.partsToConsume")}
            </Typography>
          </Grid>
          {(parts || []).map((part, index) => (
            <Grid
              item
              container
              xs={12}
              spacing={1}
              alignItems="center"
              key={`${getExpensePartSku(part)}-${index}`}
            >
              <Grid item xs={8}>
                <Typography>{getExpensePartSku(part)}</Typography>
              </Grid>
              <Grid item xs={4}>
                <Typography align="right">
                  {t("count")}: {part.count || 1}
                </Typography>
              </Grid>
            </Grid>
          ))}
          {!editableWarehouses.length ? (
            <Grid item xs={12}>
              <Typography>{t("ticketList.noWarehousesAvailable")}</Typography>
            </Grid>
          ) : null}
        </Grid>
      </DialogContent>
      <DialogActions>
        <Button
          onClick={onClose}
          color="primary"
          variant="outlined"
          disabled={loading}
        >
          {t("cancel")}
        </Button>
        <Button
          onClick={onSkip}
          color="secondary"
          variant="contained"
          disabled={loading}
        >
          {t("ticketList.continueWithoutConsumingParts")}
        </Button>
        <Button
          onClick={onConsume}
          color="primary"
          variant="contained"
          disabled={loading || !selectedWarehouse || !editableWarehouses.length}
        >
          {loading ? t("common.saving") : t("ticketList.consumeFromWarehouse")}
        </Button>
      </DialogActions>
    </Dialog>
  );
}

function Expenses({ ticketData, setTicketData, selectedTicket }) {
  const { t } = useTranslation();
  const [addNewItem, setAddNewItem] = useState(false);
  const [addPrice, setAddPrice] = useState(false);
  const [newItem, setNewItem] = useState();
  const [acKey, setACKey] = useState("sdfsdfsd");
  return (
    <Grid item xs={12} style={{ borderRadius: 5, borderWidth: 1 }}>
      <Grid item container style={{ padding: 5 }} spacing={1}>
        <Grid item xs={12}>
          <InputLabel style={{ marginBottom: 3 }}>
            {t("ticketList.spareParts")}
          </InputLabel>
        </Grid>

        {!addNewItem ? (
          <>
            <Grid item xs={addPrice ? 4 : 7}>
              <StockItemSearch
                allowNewItems={true}
                size={"small"}
                onChange={(e, v) => {
                  if (v && v.sku) {
                    if (v.sku === "Add new item") {
                      setAddNewItem(true);
                      return;
                    }
                    if (!v.costPrice) {
                      setAddPrice(true);
                    }
                    setNewItem(
                      newItem
                        ? {
                            ...newItem,
                            name: v.sku,
                            sku: v.sku,
                            stockItemId: v.id,
                            price: v.costPrice,
                          }
                        : {
                            name: v.sku,
                            sku: v.sku,
                            stockItemId: v.id,
                            price: v.costPrice,
                          },
                    );
                  }
                }}
                // clearOnSelect={true}
                includeTags={true}
                placeholder={t("orders.startSearchingProducts")}
                key={acKey + "98"}
              />
            </Grid>
            {addPrice ? (
              <Grid item xs={3}>
                <TextField
                  size="small"
                  variant="outlined"
                  label={t("stockModule.costPrice")}
                  type={"number"}
                  key={acKey + "2"}
                  onChange={(e) => {
                    if (isNaN(e.target.value)) {
                      return;
                    }
                    setNewItem(
                      newItem
                        ? {
                            ...newItem,
                            price: e.target.value,
                          }
                        : { price: e.target.value },
                    );
                  }}
                ></TextField>
              </Grid>
            ) : null}
          </>
        ) : (
          <>
            <Grid item xs={4}>
              <TextField
                size="small"
                variant="outlined"
                label={t("name")}
                onChange={(e) => {
                  setNewItem(
                    newItem
                      ? { ...newItem, name: e.target.value }
                      : { name: e.target.value },
                  );
                }}
                key={acKey + "1"}
              ></TextField>
            </Grid>
            <Grid item xs={3}>
              <TextField
                size="small"
                variant="outlined"
                label={t("stockModule.costPrice")}
                type={"number"}
                key={acKey + "2"}
                onChange={(e) => {
                  setNewItem(
                    newItem
                      ? { ...newItem, price: e.target.value }
                      : { price: e.target.value },
                  );
                }}
              ></TextField>
            </Grid>
          </>
        )}
        <Grid item xs={4}>
          <TextField
            variant="outlined"
            type="number"
            size="small"
            fullWidth
            onChange={(e) => {
              setNewItem(
                newItem
                  ? { ...newItem, count: e.target.value }
                  : { count: e.target.value },
              );
            }}
            inputProps={{ min: 0 }}
            label={t("count")}
            key={acKey + "99"}
          ></TextField>
        </Grid>
        <Grid item xs={1}>
          <IconButton
            size="small"
            color="primary"
            onClick={() => {
              if (newItem) {
                if (!newItem.name || isNaN(newItem.price) || !newItem.count) {
                  return;
                }
                var exp = {
                  ...(selectedTicket ? selectedTicket.expenses : {}),
                };
                if (ticketData && ticketData.expenses) {
                  exp = { ...ticketData.expenses };
                }
                var arr = [];
                if (exp.spareParts) {
                  arr = [...exp.spareParts];
                  arr.push(newItem);
                } else {
                  arr.push(newItem);
                }
                exp.spareParts = [...arr];
                setTicketData({
                  ...ticketData,
                  expenses: { ...exp },
                });
                setACKey(new Date().toISOString());
                setAddNewItem(false);
                setAddPrice(false);
                setNewItem();
              }
            }}
          >
            <AddIcon></AddIcon>
          </IconButton>
        </Grid>
      </Grid>

      <Grid item style={{ padding: 5 }}>
        {(ticketData &&
          ticketData.expenses &&
          ticketData.expenses.spareParts &&
          ticketData.expenses.spareParts.length) ||
        (selectedTicket &&
          selectedTicket.expenses &&
          selectedTicket.expenses.spareParts &&
          selectedTicket.expenses.spareParts.length) ? (
          <ExpenseHeader />
        ) : null}
        {[
          ...(ticketData &&
          ticketData.expenses &&
          ticketData.expenses.spareParts
            ? ticketData.expenses.spareParts
            : selectedTicket &&
                selectedTicket.expenses &&
                selectedTicket.expenses.spareParts
              ? selectedTicket.expenses.spareParts
              : []),
        ].map((m, i) => (
          <ExpenseItem
            obj={m}
            key={i}
            onClick={() => {
              var exp = {
                ...(selectedTicket ? selectedTicket.expenses : {}),
              };
              if (ticketData && ticketData.expenses) {
                exp = { ...ticketData.expenses };
              }
              var arr = [];
              arr = [...exp.spareParts];
              arr = arr.filter((a) => JSON.stringify(a) !== JSON.stringify(m));
              exp.spareParts = [...arr];
              setTicketData({
                ...ticketData,
                expenses: { ...exp },
              });
            }}
          />
        ))}
      </Grid>
      {expenseKeys.map((m) => (
        <ExpenseSegment
          key={m}
          selectedTicket={selectedTicket}
          ticketData={ticketData}
          setTicketData={setTicketData}
          expenseKey={m}
        />
      ))}

      <Grid item xs={12}>
        <Typography>
          {(ticketData && ticketData.expenses) ||
          (selectedTicket && selectedTicket.expenses)
            ? t("ticketList.totalExpenses") + ": "
            : null}

          {ticketData && ticketData.expenses
            ? Object.keys(ticketData.expenses).reduce(
                (prev, k) =>
                  ticketData.expenses[k].reduce(
                    (prev, curr) =>
                      Number(curr.price) *
                        (curr.count ? Number(curr.count) : 1) +
                      prev,
                    0,
                  ) + prev,
                0,
              ) + "€"
            : selectedTicket && selectedTicket.expenses
              ? Object.keys(selectedTicket.expenses).reduce(
                  (prev, k) =>
                    selectedTicket.expenses[k].reduce(
                      (prev, curr) =>
                        Number(curr.price) *
                          (curr.count ? Number(curr.count) : 1) +
                        prev,
                      0,
                    ) + prev,
                  0,
                ) + "€"
              : null}
        </Typography>
      </Grid>
    </Grid>
  );
}

function WhatsAppView({ selectedTicket: _selectedTicket }) {
  const ref = useRef();
  const [message, setMessage] = useState();
  const dispatch = useDispatch();
  const [acKey, setACKey] = useState("sdfasdf");
  const [selectedTicket, setSelectedTicket] = useState(_selectedTicket);

  const sendMessage = () => {
    if (!message) {
      return;
    }
    const requestOptions = {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify({
        token: getToken(),
        ticket_id: selectedTicket.id,
        message: message,
        recipient: selectedTicket.WhatsappMessages[0].WhatsappContact.number,
      }),
    };
    fetch(server + "/send_whatsapp_message", requestOptions)
      .then((res) => res.json())
      .then((result) => {
        requestErrorHandler(result, dispatch);
        if (!result.error) {
          if (result.whatsappmessage) {
            var arr = [...selectedTicket.WhatsappMessages];
            arr.push({
              ...result.whatsappmessage,
              User: { fullName: getUser().name },
            });
            setSelectedTicket({
              ...selectedTicket,
              WhatsappMessages: [...arr],
            });
            setACKey(new Date().toISOString());
          }
        }
      });
  };

  useEffect(() => {
    if (ref && ref.current) {
      // Scroll to the latest message
      ref.current.scrollTo(0, ref.current.scrollHeight);
    }
  }, [ref, acKey]);

  return (
    <>
      <Grid
        item
        xs={12}
        container
        spacing={3}
        style={{
          maxHeight: 370,
          overflowY: "scroll",
          backgroundColor: "#e8ffe8",
          borderRadius: 5,
        }}
        key={acKey}
        ref={ref}
      >
        {selectedTicket && selectedTicket.WhatsappMessages
          ? selectedTicket.WhatsappMessages.sort(
              (a, b) => Number(a.timestamp) - Number(b.timestamp),
            ).map((m, idx) => (
              <Grid
                key={idx}
                item
                xs={12}
                style={{
                  border: "1px solid #000",
                  borderRadius: 10,
                  padding: 15,
                  margin: 5,
                  boxShadow: "rgba(0, 0, 0, 0.2) 2px 2px 0px 0px",
                  backgroundColor: "lightyellow",
                }}
              >
                <Typography style={{ fontSize: 12, whiteSpace: "pre-wrap" }}>
                  {new Date(Number(m.timestamp) * 1000)
                    .toISOString()
                    .substring(0, 19)
                    .replace("T", " ")}
                  {"\n"}
                  {m.User?.fullName ||
                    `${m.WhatsappContact?.name}\n+${m.WhatsappContact?.number}`}
                </Typography>
                <hr />
                {m.type !== "text" ? (
                  <Typography>{`{ ${m.type} }`}</Typography>
                ) : null}
                <Typography>{m.data.body || m.data.caption}</Typography>
              </Grid>
            ))
          : null}
      </Grid>
      <Grid
        item
        xs={12}
        container
        alignItems="center"
        style={{ marginTop: 20 }}
      >
        <Grid item xs={11}>
          <TextField
            variant="outlined"
            label="Message"
            fullWidth
            onChange={(e) => {
              setMessage(e.target.value);
            }}
            key={acKey + "1"}
          ></TextField>
        </Grid>
        <Grid item xs={1}>
          <Button variant="contained" onClick={sendMessage}>
            Send
          </Button>
        </Grid>
      </Grid>
    </>
  );
}

const firstValue = (...values) =>
  values.find((value) => value !== undefined && value !== null && value !== "");

const mergeDeviceLists = (deviceLists) => {
  var devicesById = {};
  var mergedDevices = [];

  deviceLists.forEach((devices) => {
    (devices || []).forEach((device) => {
      if (!device?.id || devicesById[device.id]) {
        return;
      }
      devicesById[device.id] = true;
      mergedDevices.push(device);
    });
  });

  return mergedDevices;
};

function IdentificationSegment({
  setTicketData,
  Device,
  ticketData,
  selectedTicket,
  showSearch,
}) {
  const isExternalMaintenance =
    getUser()?.permissionlevel === USER_GROUPS.CLIENT_MAINTENANCE;
  const { t } = useTranslation();
  const [acKey2, setACKey2] = useState("sdfsdfsd");
  const history = useHistory();
  const dispatch = useDispatch();
  const [clientObject, setClientObject] = useState();
  const [deviceData, setDeviceData] = useState(null);
  const [suggestedDevices, setSuggestedDevices] = useState([]);
  const [loadingSuggestedDevices, setLoadingSuggestedDevices] = useState(false);

  const resolvedDeviceId =
    ticketData?.DeviceId ||
    selectedTicket?.Device?.id ||
    selectedTicket?.DeviceId ||
    Device?.id;
  const clientContactId = firstValue(
    clientObject?.contactId,
    ticketData?.ContactId,
    ticketData?.Contact?.id,
    selectedTicket?.ContactId,
    selectedTicket?.Contact?.id,
  );
  const clientCompanyId = firstValue(
    clientObject?.companyId,
    ticketData?.CompanyId,
    ticketData?.Company?.id,
    ticketData?.Contact?.CompanyId,
    selectedTicket?.CompanyId,
    selectedTicket?.Company?.id,
    selectedTicket?.Contact?.CompanyId,
  );
  const selectedDevice =
    ticketData?.Device || deviceData || selectedTicket?.Device || Device;
  const hasPersistedDevice = Boolean(
    Device || selectedTicket?.Device || selectedTicket?.DeviceId,
  );
  const hasSelectedDevice = Boolean(
    hasPersistedDevice || ticketData?.DeviceId || ticketData?.newDevice,
  );

  const [deviceProfiles, setDeviceProfiles] = useState([]);

  useEffect(() => {
    getDeviceProfiles(setDeviceProfiles, dispatch);
  }, [dispatch]);

  useEffect(() => {
    if (!resolvedDeviceId) {
      setDeviceData(null);
      return;
    }
    const requestOptions = {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify({
        token: getToken(),
        deviceid: resolvedDeviceId,
      }),
    };
    fetch(server + "/get_device_data", requestOptions)
      .then((res) => res.json())
      .then((result) => {
        requestErrorHandler(result, dispatch);
        if (!result.error) {
          setDeviceData(result.device);
        }
      });
  }, [dispatch, resolvedDeviceId]);

  useEffect(() => {
    const getCO = () => {
      var comp =
        (ticketData && ticketData.Company) ||
        (selectedTicket && selectedTicket.Company);
      var cont =
        (ticketData && ticketData.Contact) ||
        (selectedTicket && selectedTicket.Contact);
      if (!cont && !comp) {
        return;
      }

      var v = { ...contactObjectSkeleton };
      if (cont) {
        if (cont.contactId || cont.id) {
          v.contactId = cont.contactId || cont.id;
        }
        if (cont.contactName || cont.name) {
          v.contactName = cont.contactName || cont.name;
        }
        if (cont.additionalInfo && typeof cont.additionalInfo === "object") {
          Object.keys(cont.additionalInfo).forEach((key) => {
            if (Object.prototype.hasOwnProperty.call(v, key)) {
              v[key] = cont.additionalInfo[key];
            }
          });
        }
        Object.keys(cont).forEach((m) => {
          if (
            Object.keys(v).find(
              (f) => f.toLowerCase() === ("contact" + m).toLowerCase(),
            )
          ) {
            v["contact" + m[0].toUpperCase() + m.substring(1)] = cont[m];
          }
        });
      }
      if (comp) {
        if (comp.companyId || comp.id) {
          v.companyId = comp.companyId || comp.id;
        }
        if (comp.companyName || comp.name) {
          v.companyName = comp.companyName || comp.name;
        }
        if (comp.location) {
          v.location = comp.location;
        }
        if (comp.additionalInfo && typeof comp.additionalInfo === "object") {
          Object.keys(comp.additionalInfo).forEach((key) => {
            if (Object.prototype.hasOwnProperty.call(v, key)) {
              v[key] = comp.additionalInfo[key];
            }
          });
        }
        Object.keys(comp).forEach((m) => {
          if (
            Object.keys(v).find(
              (f) => f.toLowerCase() === ("company" + m).toLowerCase(),
            )
          ) {
            v["company" + m[0].toUpperCase() + m.substring(1)] = comp[m];
          }
        });
      }
      setClientObject(v);
    };
    getCO();
    return () => {
      setClientObject();
    };
  }, [selectedTicket, ticketData]);

  useEffect(() => {
    if (resolvedDeviceId || (!clientContactId && !clientCompanyId)) {
      setSuggestedDevices([]);
      setLoadingSuggestedDevices(false);
      return;
    }

    var cancelled = false;
    var abortControllers = [];
    var requests = [];
    const addSuggestionRequest = (filters) => {
      var abortcontroller = new AbortController();
      abortControllers.push(abortcontroller);
      requests.push(
        getDevices(
          {
            view: "search",
            requireLCS: false,
            ...filters,
          },
          undefined,
          abortcontroller,
        ),
      );
    };

    if (clientContactId) {
      addSuggestionRequest({ ContactId: clientContactId });
    }
    if (clientCompanyId) {
      addSuggestionRequest({ CompanyId: clientCompanyId });
    }

    setLoadingSuggestedDevices(true);
    Promise.all(requests)
      .then((deviceLists) => {
        if (!cancelled) {
          setSuggestedDevices(mergeDeviceLists(deviceLists));
        }
      })
      .finally(() => {
        if (!cancelled) {
          setLoadingSuggestedDevices(false);
        }
      });

    return () => {
      cancelled = true;
      abortControllers.forEach((abortcontroller) => {
        abortcontroller.abort();
      });
    };
  }, [clientCompanyId, clientContactId, resolvedDeviceId]);

  const setTicketClientInfo = (clientInfo) => {
    if (!clientInfo) {
      return;
    }
    var company = clientInfo.companyId
      ? {
          id: clientInfo.companyId,
          name: clientInfo.companyName,
          location: clientInfo.location,
        }
      : null;
    var contact = clientInfo.contactId
      ? {
          id: clientInfo.contactId,
          name: clientInfo.contactName,
          additionalInfo: {
            contactEmail: clientInfo.contactEmail,
            contactPhone: clientInfo.contactPhone,
          },
          CompanyId: clientInfo.companyId || null,
        }
      : null;

    setClientObject(clientInfo);
    setTicketData({
      ...ticketData,
      Company: company,
      CompanyId: clientInfo.companyId || null,
      Contact: contact,
      ContactId: clientInfo.contactId || null,
    });
  };

  const clearTicketClientInfo = () => {
    setClientObject();
    setTicketData({
      ...ticketData,
      Company: null,
      CompanyId: null,
      Contact: null,
      ContactId: null,
    });
  };

  const openClientInfo = () => {
    if (clientObject?.companyId) {
      history.push(
        (checkAdmin() ? "/cpanel" : "") +
          "/contacts/company/" +
          clientObject.companyId,
      );
      return;
    }
    if (clientObject?.contactId) {
      history.push(
        (checkAdmin() ? "/cpanel" : "") +
          "/contacts/contact/" +
          clientObject.contactId,
      );
    }
  };

  const selectExistingDevice = (device) => {
    if (!device?.id) {
      return;
    }
    setDeviceData(device);
    setTicketData({
      ...ticketData,
      Device: device,
      DeviceId: device.id,
      newDevice: undefined,
    });
  };

  const clearSelectedDevice = () => {
    setDeviceData(null);
    setTicketData({
      ...ticketData,
      Device: undefined,
      DeviceId: undefined,
      newDevice: undefined,
    });
    setACKey2(Date.now());
  };

  const clientInfoSelection = !isExternalMaintenance && (
    <>
      <Typography
        style={{ paddingTop: 10, paddingBottom: 10, fontWeight: "bold" }}
      >
        {t("ticketList.selectContact")}
      </Typography>
      <BrowseContactsDialog
        setClientInfoObject={setTicketClientInfo}
        activeObject={clientObject}
      />
      {clientObject &&
      Object.keys(clientObject).length &&
      Object.values(clientObject) ? (
        <Grid container direction="row" style={{ marginTop: 5 }}>
          <Grid item xs={10}>
            <ContactInfoBadge
              clientInfoObject={clientObject}
              direction={"row"}
              onClick={openClientInfo}
            />
          </Grid>
          <Grid item xs={2}>
            <IconButton onClick={clearTicketClientInfo}>
              <Delete />
            </IconButton>
          </Grid>
        </Grid>
      ) : null}
    </>
  );

  const suggestedDeviceSelection =
    loadingSuggestedDevices || suggestedDevices.length ? (
      <>
        <Typography
          variant="body2"
          color="textSecondary"
          style={{ marginBottom: 6 }}
        >
          {t("ticketList.suggestedDevices")}
        </Typography>
        {loadingSuggestedDevices ? (
          <Grid container alignItems="center" spacing={1}>
            <Grid item>
              <CircularProgress size={18} />
            </Grid>
          </Grid>
        ) : (
          <Grid container spacing={1} style={{ marginBottom: 10 }}>
            {suggestedDevices.map((device) => (
              <Grid item key={device.id}>
                <Button
                  size="small"
                  variant="outlined"
                  onClick={() => selectExistingDevice(device)}
                >
                  {device.serialNumber}
                </Button>
              </Grid>
            ))}
          </Grid>
        )}
        <Typography
          variant="body2"
          color="textSecondary"
          style={{ marginBottom: 6 }}
        >
          {t("ticketList.searchAllDevices")}
        </Typography>
      </>
    ) : null;

  return (
    <Grid item sm={3} xs={12}>
      <Title>{t("ticketList.receivedFrom")}</Title>
      {!hasSelectedDevice ? (
        <>
          <Typography
            style={{ paddingTop: 10, paddingBottom: 10, fontWeight: "bold" }}
          >
            {t("ticketList.selectDevice")}
          </Typography>
          {suggestedDeviceSelection}
          <DeviceSearchAutocomplete
            onChange={(e, v) => {
              if (v === undefined) {
                return;
              }
              if (v && typeof v !== "string") {
                if (v.inputValue) {
                  var x = checkNewSerialNumber(
                    v.serialNumber,
                    deviceProfiles,
                    t,
                  );
                  if (x) {
                    alert(x);
                    setTicketData({
                      ...ticketData,
                      Device: undefined,
                      DeviceId: undefined,
                      newDevice: undefined,
                    });
                    setACKey2(Date.now());
                    return;
                  }
                  setTicketData({
                    ...ticketData,
                    Device: undefined,
                    DeviceId: undefined,
                    newDevice: v.serialNumber,
                  });
                  return;
                }

                selectExistingDevice(v);
                return;
              }
              setTicketData({
                ...ticketData,
                Device: undefined,
                DeviceId: undefined,
                newDevice: undefined,
              });
            }}
            allowNewDevices={true}
            // This key hack allows to reset the element after bad input
            key={acKey2}
          />
          {clientInfoSelection}
        </>
      ) : (
        <>
          <Grid container alignItems="center" spacing={1}>
            <Grid item xs={hasPersistedDevice ? 12 : 10}>
              <Typography>
                {t("selectedDevice")}:{" "}
                {selectedDevice?.serialNumber ||
                  ticketData?.newDevice?.toUpperCase() ||
                  resolvedDeviceId}
              </Typography>
            </Grid>
            {!hasPersistedDevice ? (
              <Grid item xs={2}>
                <IconButton onClick={clearSelectedDevice}>
                  <Clear />
                </IconButton>
              </Grid>
            ) : null}
          </Grid>
          {checkAdmin() && !ticketData?.newDevice ? (
            <Typography>{getWarrantyStatusText(deviceData, t)}</Typography>
          ) : null}
          {clientInfoSelection}
        </>
      )}
    </Grid>
  );
}

function ContactMethod({ data, dense, plain, iconSpace }) {
  const val = contactMethods.find((f) => f.value === data);
  if (plain) {
    return (
      <>
        {val?.icon || iconSpace ? (
          <ListItemIcon>
            {val?.icon && React.createElement(val.icon)}
          </ListItemIcon>
        ) : null}
        {val.label}
      </>
    );
  }

  return val ? (
    <ListItem dense={!!dense}>
      {val?.icon && (
        <ListItemIcon>{React.createElement(val.icon)}</ListItemIcon>
      )}
      {val.label}
    </ListItem>
  ) : null;
}

function TicketEntry({
  device_id,
  Device,
  selectedTicket,
  setSelectedTicket,
  showTicketEntry: show,
  setShowTicketEntry: hide,
  setRefreshList,
  showSearch,
  showHeader,
  width,
  ...rest
}) {
  const isExternalMaintenance =
    getUser()?.permissionlevel === USER_GROUPS.CLIENT_MAINTENANCE;
  const [ticketData, setTicketData] = useState();
  const [showUsers, setShowUsers] = useState(false);
  const [confirmDelete, setConfirmDelete] = useState();
  const [warehouseLocation, setWarehouseLocation] = useState([]);
  const [stockConsumptionParts, setStockConsumptionParts] = useState();
  const [stockConsumptionWarehouse, setStockConsumptionWarehouse] =
    useState("");
  const [submittingTicket, setSubmittingTicket] = useState(false);
  const [showTicketHistory, setShowTicketHistory] = useState(true);
  const classes = useStyles();
  const dispatch = useDispatch();
  const { t } = useTranslation();

  useEffect(() => {
    getWarehouses(
      (warehouses) => setWarehouseLocation(warehouses || []),
      dispatch,
    );
  }, [dispatch]);

  const resetStockConsumptionDialog = () => {
    setStockConsumptionParts();
    setStockConsumptionWarehouse("");
  };

  const closeAfterSave = (result) => {
    dispatch(showPopupSnackbar(result));
    setTicketData();
    resetStockConsumptionDialog();
    setSubmittingTicket(false);
    hide(false);
    if (setRefreshList) {
      setRefreshList(new Date().toISOString());
    }
  };

  const addStockQuantity = (data) => {
    const requestOptions = {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify({
        token: getToken(),
        stock_item: data,
        relative_modification: true,
      }),
    };
    return fetch(server + "/add_stock_quantity", requestOptions)
      .then((res) => res.json())
      .then((result) => {
        requestErrorHandler(result, dispatch);
        if (result.error) {
          throw result;
        }
        return result;
      });
  };

  const consumeSparePartsFromWarehouse = (parts, warehouseName) => {
    const selectedWarehouse = warehouseLocation.find(
      (warehouse) =>
        (warehouse.name || warehouse.value) === warehouseName ||
        warehouse.value === warehouseName,
    );

    return Promise.all(
      parts.map((part) => {
        const count = Number(part.count || 1);
        const sku = getExpensePartSku(part);
        const stockItemId = getExpensePartStockItemId(part);
        const warehouse = selectedWarehouse || { name: warehouseName };

        return addStockQuantity({
          sku,
          name: part.stockItemName || part.name || sku,
          StockItem: stockItemId
            ? {
                id: stockItemId,
                sku,
                name: part.stockItemName || part.name || sku,
              }
            : undefined,
          total: count * -1,
          free: count * -1,
          warehouse: warehouse.name || warehouse.value,
          Warehouse: warehouse.id
            ? { id: warehouse.id, name: warehouse.name || warehouse.value }
            : undefined,
          reason: "maintenance " + selectedTicket?.Device?.serialNumber,
        });
      }),
    );
  };

  const handleTicketSaveResult = (result, stockConsumption) => {
    requestErrorHandler(result, dispatch);

    if (result.error) {
      setSubmittingTicket(false);
      return;
    }

    if (stockConsumption?.parts?.length && stockConsumption.warehouse) {
      consumeSparePartsFromWarehouse(
        stockConsumption.parts,
        stockConsumption.warehouse,
      )
        .then(() => {
          closeAfterSave(result);
        })
        .catch(() => {
          setSubmittingTicket(false);
        });
      return;
    }

    closeAfterSave(result);
  };

  const submitTicket = (stockConsumption) => {
    if (selectedTicket) {
      return;
    }
    if (!ticketData) {
      return;
    }
    setSubmittingTicket(true);
    const requestOptions = {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify({
        token: getToken(),
        deviceid: device_id,
        // Initial state is new unless ticketData overrides it
        ticket_data: { state: "new", ...ticketData },
      }),
    };
    fetch(server + "/add_ticket", requestOptions)
      .then((res) => res.json())
      .then((result) => {
        handleTicketSaveResult(result, stockConsumption);
      })
      .catch((error) => {
        console.log(error);
        setSubmittingTicket(false);
      });
  };

  const checkChanges = () => {
    return !ticketData;
  };

  const handleClose = () => {
    setSelectedTicket();
    setTicketData();
    setConfirmDelete();
    setShowUsers(false);
    resetStockConsumptionDialog();
    setSubmittingTicket(false);
    hide(false);
  };

  const editTicket = (deleteTicket, stockConsumption) => {
    if (!selectedTicket) {
      return;
    }
    setSubmittingTicket(true);
    const resolvedDeviceId =
      ticketData?.DeviceId ??
      selectedTicket.DeviceId ??
      selectedTicket.Device?.id ??
      device_id ??
      null;
    const requestOptions = {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify({
        token: getToken(),
        deviceid: resolvedDeviceId,
        ticket_data: {
          ...selectedTicket,
          ...ticketData,
          DeviceId: resolvedDeviceId,
        },
        deleteTicket: deleteTicket ?? undefined,
      }),
    };
    fetch(server + "/edit_ticket", requestOptions)
      .then((res) => res.json())
      .then((result) => {
        handleTicketSaveResult(result, stockConsumption);
      })
      .catch((error) => {
        console.log(error);
        setSubmittingTicket(false);
      });
  };

  const handleSubmit = () => {
    const consumableParts = getNewConsumableSpareParts(
      selectedTicket,
      ticketData,
    );
    if (consumableParts.length) {
      const editableWarehouses = warehouseLocation.filter(
        (warehouse) => warehouse.editableStock,
      );
      setStockConsumptionParts(consumableParts);
      if (editableWarehouses.length === 1) {
        setStockConsumptionWarehouse(
          editableWarehouses[0].name || editableWarehouses[0].value,
        );
      }
      return;
    }

    if (selectedTicket) {
      editTicket();
      return;
    }
    submitTicket();
  };

  const handleContinueWithoutStockConsumption = () => {
    if (selectedTicket) {
      editTicket();
      return;
    }
    submitTicket();
  };

  const handleConsumeStock = () => {
    const stockConsumption = {
      parts: stockConsumptionParts,
      warehouse: stockConsumptionWarehouse,
    };
    if (selectedTicket) {
      editTicket(undefined, stockConsumption);
      return;
    }
    submitTicket(stockConsumption);
  };
  return show ? (
    <Dialog open={!!show} fullScreen onClose={handleClose}>
      <ConsumeSparePartsDialog
        open={!!stockConsumptionParts}
        parts={stockConsumptionParts}
        warehouses={warehouseLocation}
        selectedWarehouse={stockConsumptionWarehouse}
        setSelectedWarehouse={setStockConsumptionWarehouse}
        onClose={resetStockConsumptionDialog}
        onSkip={handleContinueWithoutStockConsumption}
        onConsume={handleConsumeStock}
        loading={submittingTicket}
      />
      <DialogContent style={dialogContentStyle}>
        <DialogAppBar
          onClose={handleClose}
          header={
            !selectedTicket && showSearch ? (
              t("newTicket")
            ) : selectedTicket?.Device && showHeader ? (
              <>
                {" "}
                {selectedTicket?.Device.serialNumber} -{" "}
                <Link
                  href={"/cpanel/devices/" + selectedTicket?.Device.id}
                  style={{ color: "white" }}
                >
                  {t("viewDevicePage")}
                </Link>
              </>
            ) : null
          }
        />
        <ChangesHistoryLayout
          actions={selectedTicket?.TicketActions}
          actionKey="ticket-action"
          contentJustify="space-around"
          contentSpacing={3}
          ignoredFields={["number", "DeviceId"]}
          labelPrefixes={["ticketList"]}
          showHistory={showTicketHistory}
          setShowHistory={setShowTicketHistory}
          spacing={width === "xs" ? 0 : 1}
          style={{ marginTop: 60 }}
          width={width}
        >
          <Grid item xs={12}>
            <Title>{t("ticketList.number")}</Title>
            <Typography>
              {selectedTicket?.number ||
                t("ticketList.createTicketToGetNumber")}
            </Typography>
          </Grid>
          <IdentificationSegment
            selectedTicket={selectedTicket}
            Device={Device}
            showSearch={showSearch}
            ticketData={ticketData}
            setTicketData={setTicketData}
          />
          {!isExternalMaintenance ? (
            <Grid item sm={3} xs={12}>
              <Title>{t("ticketList.priority")}</Title>
              <TextField
                select
                fullWidth
                onChange={(e) => {
                  setTicketData({ ...ticketData, priority: e.target.value });
                }}
                variant="outlined"
                defaultValue={selectedTicket?.priority || ""}
                label={t("ticketList.priority")}
              >
                {Object.keys(TICKET_PRIORITIES).map((m) => (
                  <MenuItem key={m} value={TICKET_PRIORITIES[m]}>
                    {m}
                  </MenuItem>
                ))}
              </TextField>
            </Grid>
          ) : null}
          {!isExternalMaintenance ? (
            <Grid item sm={3} xs={12}>
              <Title>{t("ticketList.AssigneeId")}</Title>
              {selectedTicket && selectedTicket.Assignee && !showUsers ? (
                <Paper className={classes.paper}>
                  <Grid container justify="space-between" alignItems="center">
                    <Grid item>
                      <AccountCircle />
                    </Grid>
                    <Grid item>
                      <Typography>
                        {selectedTicket.Assignee.emailAddress}
                      </Typography>
                    </Grid>
                    <Grid item>
                      <IconButton
                        onClick={() => {
                          setShowUsers((e) => !e);
                          setTicketData({ ...ticketData, AssigneeId: null });
                        }}
                      >
                        <Clear />
                      </IconButton>
                    </Grid>
                  </Grid>
                </Paper>
              ) : (
                <UserSearchAutocomplete
                  required={true}
                  onChange={(e, v) => {
                    if (v) {
                      setTicketData({ ...ticketData, AssigneeId: v.id });
                      return;
                    }
                    setTicketData({ ...ticketData, AssigneeId: undefined });
                  }}
                  userGroup={"CTN"}
                  additionalDataFields={["emailAddress"]}
                ></UserSearchAutocomplete>
              )}
            </Grid>
          ) : null}
          <Grid item sm={3} xs={12}>
            <Title> {t("ticketList.state")}</Title>
            <TextField
              variant="outlined"
              select
              fullWidth
              defaultValue={selectedTicket?.state ?? "new"}
              label={t("ticketList.state")}
              onChange={(e, v) => {
                setTicketData({ ...ticketData, state: e.target.value });
              }}
            >
              {ticketStates.map((option) => (
                <MenuItem key={option.value} value={option.value}>
                  {t("ticketList." + option.value)}
                </MenuItem>
              ))}
            </TextField>
          </Grid>
          <Grid xs={12} item>
            {selectedTicket?.summary ? (
              <>
                {" "}
                <hr />
                <Title>{t("ticketList.summary")}</Title>
                <Typography style={{ whiteSpace: "pre-wrap" }}>
                  {selectedTicket.summary}
                </Typography>
              </>
            ) : null}

            <hr />
            <Title>{t("ticketList.backgroundInfo")}</Title>
          </Grid>
          <Grid item xs={12}>
            <Typography
              style={{
                paddingTop: 10,
                paddingBottom: 10,
                fontWeight: "bold",
              }}
            >
              {t("ticketList.description")}
            </Typography>
            {selectedTicket?.description ? (
              <Typography style={{ whiteSpace: "pre-wrap" }}>
                {selectedTicket?.description}
              </Typography>
            ) : (
              <TextField
                variant="outlined"
                fullWidth
                multiline
                defaultValue={selectedTicket?.description}
                rows={4}
                placeholder={t("ticketList.descriptionPlaceholder")}
                label={t("ticketList.description")}
                onChange={(e) => {
                  if (e.target.value) {
                    setTicketData({
                      ...ticketData,
                      description: e.target.value,
                    });
                    return;
                  }
                  setTicketData({ ...ticketData, description: null });
                }}
              ></TextField>
            )}
          </Grid>
          <Grid item xs={12}>
            <Typography
              style={{
                paddingTop: 10,
                paddingBottom: 10,
                fontWeight: "bold",
              }}
            >
              {t("ticketList.details")}
            </Typography>
            {selectedTicket?.details ? (
              <Typography style={{ whiteSpace: "pre-wrap" }}>
                {selectedTicket.details}
              </Typography>
            ) : (
              <TextField
                variant="outlined"
                fullWidth
                multiline
                placeholder={t("ticketList.detailsPlaceholder")}
                defaultValue={selectedTicket?.details}
                rows={4}
                label={t("ticketList.details")}
                onChange={(e) => {
                  if (e.target.value) {
                    setTicketData({
                      ...ticketData,
                      details: e.target.value,
                    });
                    return;
                  }
                  setTicketData({ ...ticketData, details: null });
                }}
              ></TextField>
            )}
          </Grid>
          <Grid item xs={12}>
            <hr />
            <Title>{t("ticketList.actionsTaken")}</Title>
          </Grid>
          <Grid item xs={12}>
            <Typography
              style={{
                paddingTop: 10,
                paddingBottom: 10,
                fontWeight: "bold",
              }}
            >
              {t("ticketList.clientContacted")}
            </Typography>
            {/* {selectedTicket?.clientContacted ? (
                  <ContactMethod data={selectedTicket.clientContacted} />
                ) : ( */}
            <TextField
              fullWidth
              select
              label={t("ticketList.clientContacted")}
              variant="outlined"
              onChange={(e) => {
                setTicketData({
                  ...ticketData,
                  clientContacted: e.target.value,
                });
              }}
            >
              {contactMethods.map((m) => (
                <MenuItem value={m.value} label={m.label} key={m.value}>
                  <ContactMethod data={m.value} plain={true} iconSpace={true} />
                </MenuItem>
              ))}
            </TextField>
            {/* )} */}
          </Grid>
          <Grid item xs={12}>
            <Typography
              style={{
                paddingTop: 10,
                paddingBottom: 10,
                fontWeight: "bold",
              }}
            >
              {t("ticketList.actionDescription")}
            </Typography>
            <TextField
              variant="outlined"
              fullWidth
              multiline
              // Show default value if History is not available
              defaultValue={
                selectedTicket?.TicketActions &&
                selectedTicket?.TicketActions.length
                  ? null
                  : selectedTicket?.action
              }
              rows={4}
              placeholder={t("ticketList.actionPlaceholder")}
              label={t("ticketList.action")}
              onChange={(e) => {
                if (e.target.value) {
                  setTicketData({ ...ticketData, action: e.target.value });
                  return;
                }
                setTicketData({ ...ticketData, action: null });
              }}
            ></TextField>
          </Grid>
          {!isExternalMaintenance ? (
            <Grid item xs={12}>
              <DetailTabs
                activeTabs={[
                  width === "xs"
                    ? {
                        permission: [USER_GROUPS.ADMIN, USER_GROUPS.SUPER_USER],
                        label: t("ticketList.changesHistory"),
                        content: (
                          <ChangesHistory
                            actions={selectedTicket?.TicketActions}
                            actionKey="ticket-action"
                            ignoredFields={["number", "DeviceId"]}
                            labelPrefixes={["ticketList"]}
                          />
                        ),
                      }
                    : null,
                  {
                    permission: [USER_GROUPS.ADMIN, USER_GROUPS.SUPER_USER],
                    label: t("media"),
                    content: <MediaFiles ticket={selectedTicket} />,
                  },
                  {
                    permission: [USER_GROUPS.ADMIN, USER_GROUPS.SUPER_USER],
                    label: t("ticketList.email"),
                    content: (
                      <EmailMessages
                        selectedTicket={
                          selectedTicket
                            ? { ...selectedTicket, ...(ticketData || {}) }
                            : selectedTicket
                        }
                      />
                    ),
                  },
                  {
                    permission: [USER_GROUPS.ADMIN, USER_GROUPS.SUPER_USER],
                    label: t("ticketList.expenses"),
                    content: (
                      <Expenses
                        ticketData={ticketData}
                        setTicketData={setTicketData}
                        selectedTicket={selectedTicket}
                      />
                    ),
                  },
                  // {
                  //   permission: [USER_GROUPS.SUPER_USER],
                  //   label: "WhatsApp",
                  //   content: <WhatsAppView selectedTicket={selectedTicket} />,
                  //   disabled: true,
                  // },
                ]}
              />
            </Grid>
          ) : null}
          <Grid item xs={12} style={actionBarSpacerStyle}>
            {/* Spacing for floating buttons */}
          </Grid>
        </ChangesHistoryLayout>
        <div style={actionBarStyle}>
          <Grid container item xs={12} spacing={3}>
            <Grid item>
              <Button
                disabled={checkChanges() || submittingTicket}
                variant="contained"
                color="primary"
                onClick={handleSubmit}
              >
                {t("submit")}
              </Button>
            </Grid>
            <Grid item>
              <Button variant="outlined" onClick={handleClose}>
                {t("cancel")}
              </Button>
            </Grid>
            {selectedTicket && !confirmDelete && !isExternalMaintenance ? (
              <Grid item>
                <Button
                  variant="contained"
                  color="secondary"
                  onClick={() => {
                    setConfirmDelete(true);
                  }}
                >
                  {t("delete")}
                </Button>
              </Grid>
            ) : null}
            {confirmDelete ? (
              <Grid item>
                <Typography>{t("areYouSure")}?</Typography>
                <Button
                  variant="contained"
                  color="secondary"
                  disabled={submittingTicket}
                  onClick={() => {
                    editTicket(true);
                    setConfirmDelete(false);
                  }}
                >
                  {t("confirmDelete")}
                </Button>
                <Button
                  variant="outlined"
                  onClick={() => {
                    setConfirmDelete(false);
                  }}
                >
                  {t("cancel")}
                </Button>
              </Grid>
            ) : null}
          </Grid>
        </div>
      </DialogContent>
    </Dialog>
  ) : null;
}

export default withWidth()(TicketEntry);
